import { GameMode } from '../types';
import type { ModeDescription } from './types';

export const STANDARD_MODE: ModeDescription = {
  mode: GameMode.STANDARD,
  title: 'Standard',
  description: '3 lives. Wrong answers burn countries.',
  icon: '❤️',
};
